module.exports = __webpack_public_path__ + "static/media/arbogavapen.8ac65873.png";